import React, {Component} from 'react'
import {Route, Redirect, withRouter, Switch} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import './index.css'

import {
  authenticateUser
} from '../../stores/auth'

import ViewAllSalesOrders from '../../containers/ViewAllSalesOrders'
import ViewSalesOrder from '../../containers/ViewSalesOrder'
import Upload from '../../containers/Upload'
import AuthRoute from '../../containers/AuthRoute'
import Login from '../../containers/Login'
import ViewAllInvoices from '../../containers/ViewAllInvoices'
import API from '../../containers/API'

class App extends Component {
  componentDidMount() {
    this.props.authenticateUser()
  }

  render() {
    const {authenticated} = this.props

    return (
      <div className='App'>
        <main>
          {
            authenticated ?
              <Switch>
                <AuthRoute exact path='/' component={Upload}/>
                <AuthRoute exact path='/orders' component={ViewAllSalesOrders}/>
                <AuthRoute exact path='/orders/:sfid' component={ViewSalesOrder}/>
                <AuthRoute exact path='/invoices' component={ViewAllInvoices}/>
                <AuthRoute exact path='/upload/' component={Upload}/>
                <AuthRoute exact path='/api' component={API}/>
                {/* Authenticated users can never land on a route-less path
                    (e.g. /login after sign-in) — that rendered a blank screen. */}
                <Redirect to='/'/>
              </Switch> :
              <Route exact path="/login" component={Login}/>
          }
          </main>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({
      authenticateUser
    }, dispatch)
  }
}

const mapStateToProps = (state, route) => {
  const {authenticated} = state.stores.auth

  return ({
    ...route.match.params,
    authenticated
  })
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))

